module.exports = __webpack_public_path__ + "assets/rhino-core-shield.f3aeb326.svg";